/**
 * Trend (diagonal) line interaction, co-located with the tool (Phase 5). A
 * plain two-anchor segment — start/end, no body drag. The chart's shared
 * handlers call these pure helpers for placement, drag, and preview.
 */
import type { DiagonalLine } from "@/state/slices/uiSlice";
import type { DragTarget } from "@/components/Chart/types";

type Point = { time: number; price: number };

export function buildDiagonalLine(a: Point, b: Point): DiagonalLine {
  return {
    id: `diag_${Date.now()}`,
    startTime: a.time,
    startPrice: a.price,
    endTime: b.time,
    endPrice: b.price,
  };
}

export function diagonalPreview(anchor: Point, hover: Point): DiagonalLine {
  return {
    id: "preview-diagonal",
    startTime: anchor.time,
    startPrice: anchor.price,
    endTime: hover.time,
    endPrice: hover.price,
  };
}

export function diagonalDragPartial(
  drag: Extract<DragTarget, { type: "diagonal" }>,
  time: number | null,
  price: number | null,
): Partial<Omit<DiagonalLine, "id">> | null {
  const partial: Partial<Omit<DiagonalLine, "id">> = {};
  if (time != null) {
    if (drag.anchor === "start") partial.startTime = time;
    else partial.endTime = time;
  }
  if (price != null) {
    if (drag.anchor === "start") partial.startPrice = price;
    else partial.endPrice = price;
  }
  return Object.keys(partial).length > 0 ? partial : null;
}
